import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
import { NavLink } from 'react-router-dom';
const Content = [
{
    subTitle: 'Make a checklist of your items',
    Content: 'First, make a checklist of what household items you required. Everyone"s list is different because it all depends on how much time do you have. Some people have two months for packing while some have only two weeks. So, arrange your checklist accordingly.',
    id: 1
},
{
    subTitle: 'Categorize so you can pick less',
    Content: 'A crucial packing tip is to make a list of things you do not need. You can lighten your stress and workload by sell or donate all the stuff you no longer need. Measure the new place where you are going and get rid of all furniture that will not fit in your new location.',
    id: 2
},
{
    subTitle: 'Purchase some quality moving boxes',
    Content: 'If you want to put heavy things in boxes, then buy boxes of good quality, so they do not fall apart in your hands while you are trying to move it into other places. Grocery boxes or reused boxes can be compromised due to moisture.',
    id: 3
},
{
    subTitle: 'First pack essential things',
    Content: 'When you are moving to a new place first pack the things which you needed most, because all the boxes contain the same color, so you do not mix the essential stuff.',
    id: 4
},
{
    subTitle: 'Use the color packing label.',
    Content: 'To stay organized, use the color label and put it on boxes. This moving tip can save your ton of time. You do not have to get panic for finding the important material. ',
    id: 5
},
{
    subTitle: 'Do not overload your moving box',
    Content: 'A lot of people made a massive mistake while moving; they cram all their belongings in a few boxes and overload them. As a result, the box itself unbox in your hand. Use as many boxes as you need to create easy-to-lift loads. Try to keep your most jumbo boxes to not more than fifty pounds.',
    id: 6
},
{
    subTitle: 'Use the right box for the right material',
    Content: 'Put heavy material like books in small boxes and light things in large boxes to make it easier for the mover to organize and pack all boxes in the moving truck. Make sure to put heavier items on the bottom and the lighter one on the top to avoid damaging the fragile items.',
    id: 7
},
{
    subTitle: 'Fill all the spaces in the box',
    Content: 'After putting all the material in the box, if the small spaces left then, fill that spaces with packing paper, clothing or form, peanuts, etc. Use tape at the bottom and top of the box. You can also use tape in places where stress is concentrated.',
    id: 8
},


];
class Tips extends Component{
    render(){
        let title = 'How to move in Bad Weather ';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Moving in Bad Weather' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Moving in Bad Weather'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-9 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50">Not everyone has the luxury of being able to move when it's nice and sunny outside. Plenty of people find themselves having to move at less opportune times, including those when the weather is worse than just undesirable. This winter was a great example of how bad weather can be. With the blizzards and snow that have crippled certain areas of the country, one might think that the moving and relocation industry had no choice but to put things in 'pause.' Though severe weather is problematic, it certainly doesn't bring the entire relocation industry to a standstill.</p>
                                            <p className="description text-left pt--10">Choosing to move during a time of the year when bad weather is common can actually be a good idea if you are looking for ways to save money on moving. Often, rainy season and the time of year when it snows are the same times as when business to the movers slows down. As such, you might net a good deal on the moving services you need without sacrificing quality. Knowing how to prepare for the move, and any potential weather threats that may occur simultaneously can save you even more as you will reduce the trouble, time, and stress that movers have to put into a project. Here are a few things you can do to prepare for your move during such times.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Preparations</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>First and foremost, no matter what time of the year you are planning on moving, be sure that you follow the news and pay close attention to the weather reports as moving day gets closer. Long-distance movers will need to keep an eye on the weather along the route from their old home to their new one, while local movers have a much simpler job. Keep the weather channel on when you pack your things and get into a 'weather' state of mind. You'll see trends emerge, and you'll be able to tell what's coming your way, pinning down actual weather as the day gets closer.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Winter Weather</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Wind can be problematic during a move for many reasons, the least of which is not just the idea that the moving truck is so big and not so aerodynamic. If the wind isn't strong, then a bit more care can often prevent problems associated with the wind, but when the wind approaches gale force, it is usually safer to postpone the move and wait until the storm is over. It's always better to be safe than sorry, though storms like these generally pop up out of nowhere.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>In this and all other cases, it is important to keep your ear on the weather reports leading up to moving day and make changes as they are needed. In the end, this will help you ensure that your things make it safely to your new home, even if you have to move during a time of the year that is prone to poor weather.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Hail and Rain</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>The rain never stopped a mover before. In fact, most moving companies come prepared to handle transporting your things from your home to the moving truck even in the event of rain. Using tarps to cover your goods can protect anything from the moisture that could damage them. For hail, they use the same methods but employ padded tarps that will protect things from the damage of rock-solid ice that falls from the sky. You can often save some time by covering some things before the movers arrive, but most of the time, it is better to allow the professionals who have the experience to handle this aspect of things. Cover your cardboard boxes when you move out because they don’t do a good job of keeping the rain out. Use the masking tape to tape the crack to keep the rainwater from leaking through. Also, cover the cloths and other items that can absorb the water easily. Remember, before you allow the loading to begin, walk out to the moving truck and ask for a quick inspection to make sure that there are no leaks that might allow rain to reach your things inside.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Wind</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>The crazy extremes of this winter brought with it plenty of lessons to be learned for several industries. However, many moving companies have already known a lot about the logistics involved in transporting things during bad winter storms. With trucks and equipment that is rated for winter use, the right company like <a href="/"><b>Moonline moving</b></a> will offer the safest possible experience no matter what kind of winter weather they run into between your old home and your new one.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>But, the movers aren't the only ones that can help make the process better overall. If the weather is turning colder, and it looks like snow is coming, prepare your location and destination for the movers. The best way to do this is to salt sidewalks and driveways while clearing them off and keeping them clear to prevent falls. If it looks like it will be snowing when you are loading the truck, or unloading it, prepare for the use of tarps that are usually provided by the moving companies Vancouver.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'10px'}}>Before hiring a mover, ask about their experience in moving during the winter. Moving trucks should be equipped with winter tires or chains as needed for the areas where they will be operating.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Bottom Line:</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>As you know, the weather can be unpredictable, and it doesn’t care about your moving day. So don’t think about the bad weather and not let it add stress to your move. The tips mentioned above will surely help you to plan and prepare for moving in bad weather and make it smoother. So, nothing can stop you from moving to your new home on the day you have decided to move.</p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}><NavLink to="/"><b>Moon Line moving</b></NavLink> helps you to move to your destinations around Canada seven days a week, even shine or rain. Give us a call today at <b>+1 604 595 2800</b> for a 100% free <NavLink to="/booknow"><b>moving quote</b></NavLink> and get information about your move.</p>
                                        </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;